import { render, staticRenderFns } from "./user-dialog.vue?vue&type=template&id=4b250e36&scoped=true"
import script from "./user-dialog.vue?vue&type=script&lang=js"
export * from "./user-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-dialog.vue?vue&type=style&index=0&id=4b250e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b250e36",
  null
  
)

export default component.exports